import _isNil from 'lodash/isNil';
import _some from 'lodash/some';
import { gqlFeatureEnum as FEATURE } from '@minecraft.graphql-types';
import { GetInitialRolePreferencesArgs, SelectOption, FiltersNameEnum } from '../types';
import { useExtraWorkOption } from './useExtraWorkOption';

export const useInitialRolePreferences = () => {
  const extraWorkOption = useExtraWorkOption();

  return ({
    isSubmissionContext,
    accountOrgFeatures,
    appliedFilters,
  }: GetInitialRolePreferencesArgs): SelectOption[] => {
    const isAppliedFiltersNotExist = _isNil(appliedFilters);

    const isAccountOrgWithExtrasWorkFeature = _some(accountOrgFeatures, {
      code: FEATURE.SET_DEFAULTS_TO_BACKGROUND_FOR_EXTRAS_CASTING,
    });

    if (!isSubmissionContext && isAppliedFiltersNotExist && isAccountOrgWithExtrasWorkFeature) {
      return [extraWorkOption];
    }

    return appliedFilters?.[FiltersNameEnum.rolePreferences] || [];
  };
};
